import React, { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { FaRegCopy } from "react-icons/fa6";
import "sweetalert2/dist/sweetalert2.min.css";
import SelectNetworkDropdown from "./SelectNetworkDropdown";
import { SyncLoader } from "react-spinners"; 

const SendModal = ({ isOpen, onClose }) => {

  const { evmKey, activeToken, token, activeNetwork } = useSelector((state) => state.user);

  const testNetworks = [
    { name: "Sepolia testnet", chainId: 11155111 },
    { name: "Polygon Amoy", chainId: 80002 },
    { name: "BSC testnet", chainId: 97 },
    { name: "Solana DevNet", chainId: 103 },  
  ];

  const mainNetworks = [
    { name: "Ethereum Mainnet", chainId: 1 },
    { name: "Polygon", chainId: 137 },
    { name: "BSC", chainId: 56 },
    { name: "Avalanche C-Chain Mainnet", chainId: 43114 },
    { name: "Solana MainNet", chainId: 101 },
  ];
  const [selectedNetwork, setSelectedNetwork] = useState(null);

  const [assets, setAssets] = useState([]);
  
  const [loadingAssets, setLoadingAssets] = useState(false);
  const resetForm = useCallback(() => {
    setAssets([]);
    setSendFrom("");
    setSendTo("");
    setAsset("");
    setAmount("");
    setSelectedAsset(null);
    setSelectedAssetBalance(null);
    setSelectedAssetIndex(null);
    setFeeMessage("");
    setLoading(false);
    setTransactionDetails(null);
  }, []);
  const handleSelectChange = (e) => {
    const selectedChainId = parseInt(e.target.value);
    const network = availableNetworks.find((net) => net.chainId === selectedChainId);
    setSelectedNetwork(network);
  
  };

  const [availableNetworks, setAvailableNetworks] = useState([]);
const [showMainnet, setShowMainnet] = useState(false);
const [showTestnet, setShowTestnet] = useState(false);
  
const fetchNetworkMode = async () => {
  try {
    const response = await axios.get("https://looknatest.com/wallet/wallet/checkNetworkMode", {
      headers: { authorization: `Bearer ${token}` },
    });

    if (response.status === 200) {
      const { showMainnet, showTestnet } = response.data;
      setShowMainnet(showMainnet);
      setShowTestnet(showTestnet);

      if (response.data?.showMainnet && response.data?.showTestnet) {
        const combined = [...mainNetworks, ...testNetworks];
        setAvailableNetworks(combined);
        if (!selectedNetwork) setSelectedNetwork(combined[0]);
      } else if (response.data?.showMainnet) {
        setAvailableNetworks(mainNetworks);
        if (!selectedNetwork) setSelectedNetwork(mainNetworks[0]);
      } else if (response.data?.showTestnet) {
        setAvailableNetworks(testNetworks);
        if (!selectedNetwork) setSelectedNetwork(testNetworks[0]);
      } else {
        setAvailableNetworks([]);
      }
      
    }
  } catch (err) {
    console.error("Failed to check network mode:", err);
  }
};


  useEffect(() => {
    resetForm();

    if (selectedNetwork) {
      const chainId = selectedNetwork.chainId;
      setLoadingAssets(true); // start loader
  
      const assetUrl = `https://looknatest.com/wallet/wallet/getAssetsByChain?chainId=${chainId}`;
      axios
        .get(assetUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          const fetchedAssets = response.data.Assets || [];
          console.log(`Fetched assets: ${JSON.stringify(fetchedAssets, null, 2)}`);
          setAssets(fetchedAssets);
  
          // Auto-set balance and asset index only — NOT setAsset()
          if (fetchedAssets.length > 0) {
            const first = fetchedAssets[0];
            setSelectedAsset(first);                    // Safe: just metadata
            setSelectedAssetBalance(first.balance ?? "0"); // Show balance
            setSelectedAssetIndex(0);                  // Helpful for UI
            // Do NOT call setAsset() here — keeps transaction logic safe
          }
        })
        .catch((error) => {
          console.error("Error fetching assets:", error);
        })
        .finally(() => setLoadingAssets(false));
  
      // Fetch public key for Send From
      const fetchPublicKey = async () => {
        try {
          let keyResponse;
          if (chainId === 101 || chainId === 103) {
            keyResponse = await axios.get("https://looknatest.com/wallet/wallet/getSolanaPKey", {
              headers: { Authorization: `Bearer ${token}` },
            });
          } else {
            keyResponse = await axios.get("https://looknatest.com/wallet/wallet/getPublicKeyEvmGenerated", {
              headers: { Authorization: `Bearer ${token}` },
            });
          }
  
          const key = keyResponse.data?.key || "";
          setSendFrom(key);
          setSelectedAssetBalance("0"); // Reset before selecting
        } catch (err) {
          console.error("Error fetching public key:", err);
          setSendFrom("");
        }
      };
  
      fetchPublicKey();
    }
  }, [selectedNetwork, resetForm,activeToken]);
  
    // when modal closes, reset form
    useEffect(() => {
      if (!isOpen) {
        resetForm();
      }
    }, [isOpen, resetForm]);
// end 
  const [sendFrom, setSendFrom] = useState("");
  const [sendTo, setSendTo] = useState("");
  const [asset, setAsset] = useState("");
  const [amount, setAmount] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [transactionDetails, setTransactionDetails] = useState(null);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [selectedAssetIndex, setSelectedAssetIndex] = useState(null);

  const [selectedAssetBalance, setSelectedAssetBalance] = useState(null);
  const [feeMessage, setFeeMessage] = useState("");
  
  const navigate = useNavigate();
  useEffect(() => {
    if (isOpen) {
      fetchNetworkMode(); 
      fetchAddress();
    }
  }, [isOpen]);
  
  const fetchAddress = async () => {
    try {
      let response;
      if (activeNetwork?.chainId === 103 || activeNetwork?.chainId === 101) {
        response = await axios.get("https://looknatest.com/wallet/wallet/getSolanaPKey", {
          headers: { authorization: `Bearer ${token}` },
        });
      } else {
        response = await axios.get("https://looknatest.com/wallet/wallet/getPublicKeyEvmGenerated", {
          headers: { authorization: `Bearer ${token}` },
        });
      }
     
   
      // set response for 403 to redirect to connect-wallet page
      if (response?.status === 403) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          title: "Enter your password",
          showConfirmButton: false,
          timer: 2000,
          background: "#f44336",
          color: "#fff",
        });
        navigate("/connect-wal");
        return;
      }
      setSendFrom(response?.data?.key);
    } catch (error) {
      console.error("Error fetching address:", error);
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: error?.response?.data?.error || "Error fetching address",
        showConfirmButton: false,
        timer: 2000,
        background: "#f44336",
        color: "#fff",
      });
      if (error?.response?.status === 403) {
        navigate("/connect-wal");
        return;
      }
    }
  };
 
  const handleSend = async (e) => {
    e.preventDefault();
  
    // const result = await Swal.fire({
    //   title: 'Confirm Transaction',
    //   html: `
    //     <div style="text-align: left; font-family: 'Arial', sans-serif; font-size: 14px; color: #333;">
    //       <div id="txDetails" style="padding: 10px; border: 1px solid #eee; border-radius: 8px; background: #f9f9f9; margin-bottom: 15px;">
    //         <p><strong>Send From:</strong> ${sendFrom}</p>
    //         <p><strong>Send To:</strong> ${sendTo}</p>
    //         <p><strong>Amount:</strong> ${amount}</p>
    
    //         ${
    //           selectedAsset
    //             ? `<div style="display: flex; align-items: center; margin-top: 10px; gap: 8px;">
    //                  <img 
    //                    id="tokenLogo"
    //                    src="${selectedAsset.logo}" 
    //                    alt="${selectedAsset.symbol}" 
    //                    style="width: 24px; height: 24px;" 
    //                    onerror="this.style.display='none'; document.getElementById('fallbackAsset').style.display='flex';"
    //                  />
    //                  <span id="tokenSymbol" style="font-weight: bold;">${selectedAsset.symbol}</span>
            
    //                  <div id="fallbackAsset" style="display: none; align-items: center; gap: 6px;">
    //                    <span style="font-size: 18px;">💠</span>
    //                    <span style="font-weight: bold; color: gray;">Unknown</span>
    //                  </div>
    //                </div>`
    //             : ""
    //         }
            
    //       </div>
    
    //       <button id="copyButton" style="background-color: #3085d6; color: white; border: none; padding: 8px 12px; border-radius: 5px; cursor: pointer; font-size: 13px; margin-bottom: 15px;">
    //         Copy Details
    //       </button>
    
    //       <p style="color: #cc0000; font-size: 13px; margin-top: 10px;">
    //         Please double-check all transaction details. Transactions are irreversible once submitted.
    //       </p>
    
    //       <p style="color: #2e7d32; font-weight: bold; font-size: 15px; margin-top: 10px;">
    //         Are you sure you want to proceed?
    //       </p>
    //     </div>
    //   `,
    //   icon: 'warning',
    //   showCancelButton: true,
    //   confirmButtonText: ' Confirm',
    //   cancelButtonText: ' Cancel',
    //   reverseButtons: true,
    //   background: "#ffffff",
    //   confirmButtonColor: '#3085d6',
    //   cancelButtonColor: '#d33',
    //   didOpen: () => {
    //     const copyButton = Swal.getPopup().querySelector('#copyButton');
    //     const txDetails = Swal.getPopup().querySelector('#txDetails');
    //     copyButton.addEventListener('click', () => {
    //       navigator.clipboard.writeText(txDetails.innerText).then(() => {
    //         copyButton.innerText = "Copied!";
    //         setTimeout(() => copyButton.innerText = "Copy Details", 2000);
    //       });
    //     });
    //   }
    // });
    const result = await Swal.fire({
  title: 'Confirm Transaction',
  html: `
    <div style="text-align: left; font-family: 'Arial', sans-serif; font-size: 14px; color: #fff;">
      <div id="txDetails" style="padding: 10px; border: 1px solid #eee; border-radius: 8px; background: #23232c; margin-bottom: 15px;">
        <p><strong>Send From:</strong> ${sendFrom}</p>
        <p><strong>Send To:</strong> ${sendTo}</p>
        <p><strong>Amount:</strong> ${amount}</p>

        ${
          selectedAsset
            ? `<div style="display: flex; align-items: center; margin-top: 10px; gap: 8px;">
                 <img 
                   id="tokenLogo"
                   src="${selectedAsset.logo}" 
                   alt="${selectedAsset.symbol}" 
                   style="width: 24px; height: 24px;" 
                   onerror="this.style.display='none'; document.getElementById('fallbackAsset').style.display='flex';"
                 />
                 <span id="tokenSymbol" style="font-weight: bold;">${selectedAsset.symbol}</span>
        
                 <div id="fallbackAsset" style="display: none; align-items: center; gap: 6px;">
                   <span style="font-size: 18px;">💠</span>
                   <span style="font-weight: bold; color: gray;">Unknown</span>
                 </div>
               </div>`
            : ""
        }
      </div>
      <button id="copyButton" style="background-color: #3085d6; color: white; border: none; padding: 8px 12px; border-radius: 5px; cursor: pointer; font-size: 13px; margin-bottom: 15px;">
        Copy Details
      </button>
      <p style="color: #ff8a80; font-size: 13px; margin-top: 10px;">
        Please double-check all transaction details. Transactions are irreversible once submitted.
      </p>
      <p style="color: #2e7d32; font-weight: bold; font-size: 15px; margin-top: 10px;">
        Are you sure you want to proceed?
      </p>
    </div>
  `,
  icon: 'warning',
  showCancelButton: true,
  confirmButtonText: ' Confirm',
  cancelButtonText: ' Cancel',
  reverseButtons: true,
  background: "rgba(40, 40, 40, 0.3)", // glassy color
  color: "#fff",
  customClass: {
    popup: 'glass-modal'
  },
  confirmButtonColor: '#3085d6',
  cancelButtonColor: '#d33',
  didOpen: () => {
    const copyButton = Swal.getPopup().querySelector('#copyButton');
    const txDetails = Swal.getPopup().querySelector('#txDetails');
    copyButton.addEventListener('click', () => {
      navigator.clipboard.writeText(txDetails.innerText).then(() => {
        copyButton.innerText = "Copied!";
        setTimeout(() => copyButton.innerText = "Copy Details", 2000);
      });
    });
  }
});
    
  
    if (result.isConfirmed) {
      setLoading(true);
      let assetData = asset.split(",");
      console.log(`the assetData before the split is ${assetData}`)
      const chainId = selectedNetwork.chainId;
      const isDevnet = chainId === 103;
  
      const basePayload = {
        generatedKey: true,
        ...(isDevnet && { network: "devnet" }),
      };
  
      try {
        let res;
        const evmChains = [11155111, 80002, 137, 1, 43113, 43114, 56, 97];
        const solanaChains = [101, 103];
        const isEvm = evmChains.includes(chainId);
        const isSolana = solanaChains.includes(chainId);
        const isNativeAsset = asset == "Native"; // Native asset handling
  
        if (isEvm) {
          if (isNativeAsset) {
            // EVM native (ETH, MATIC, etc.)
            res = await axios.post(
              "https://looknatest.com/wallet/wallet/sendEth",
              { chainId:selectedNetwork.chainId, address: sendTo, amount, importedKey: false },
              { headers: { Authorization: `Bearer ${token}` } }
            );
          } else {
            // ERC-20 tokens on EVM
            res = await axios.post(
              "https://looknatest.com/wallet/wallet/sendErc20",
              { chainId:selectedNetwork.chainId, to: sendTo, amount, tokenAddress: asset, importedKey: false },
              { headers: { Authorization: `Bearer ${token}` } }
            );
          }
        } else if (isSolana) {
          if (isNativeAsset) {
            // Solana native (SOL)
            res = await axios.post(
              "https://looknatest.com/wallet/wallet/sendSol",
              { to: sendTo, amount, ...basePayload },
              { headers: { Authorization: `Bearer ${token}` } }
            );
          } else {
            // SPL token on Solana
            res = await axios.post(
              "https://looknatest.com/wallet/wallet/sendSplToken",
              { tokenMintAddress: asset, recieverAddress: sendTo, amount, ...basePayload },
              { headers: { Authorization: `Bearer ${token}` } }
            );
          }
        } else {
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "error",
            title: "Unsupported network selected.",
            showConfirmButton: false,
            timer: 2000,
            background: "#f44336",
            color: "#fff",
          });
        }
  
        if (res?.status === 200) {
          setTransactionDetails(res.data);
          setData(res.data);
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Transaction executed successfully",
            showConfirmButton: false,
            timer: 2000,
            background: "#be6bed",
            color: "#fff",
          });
        } else {
          throw new Error("Transaction failed");
        }
      } catch (error) {
        const getErrorMessage = (error) => {
          return (
            error?.response?.data?.error ||
            error?.response?.data?.message ||
            error?.message ||
            "Transaction failed!"
          );
        };
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "error",
          title: getErrorMessage(error),
          showConfirmButton: false,
          timer: 2000,
          background: "#f44336",
          color: "#fff",
        });
      } finally {
        setLoading(false);
      }
    } else {
      console.log('Transaction canceled by user');
    }
  };
  
  
  const handleCopy = () => {
    const input = document.createElement("input");
    input.value = data?.hash; // You can use other data you want to copy
    document.body.appendChild(input);
    input.select();
    input.setSelectionRange(0, 99999); // For mobile devices

    const successful = document.execCommand("copy");
    if (successful) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Address copied successfully!",
        showConfirmButton: false,
        timer: 2000,
        background: "#be6bed",
        color: "#fff",
      });
    } else {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Failed to copy address!",
        showConfirmButton: false,
        timer: 2000,
        background: "#be6bed",
        color: "#fff",
      });
    }
    document.body.removeChild(input);
  };
  if (!isOpen) return null;

  
  return (
    <>
      {loading ? (
        <div className="modal-overlay">
          <div className="modal-container">
            <div className="content-center">
              <div className="dot-spinner">
                <div className="dot-spinner__dot"></div>
                <div className="dot-spinner__dot"></div>
                <div className="dot-spinner__dot"></div>
                <div className="dot-spinner__dot"></div>
                <div className="dot-spinner__dot"></div>
                <div className="dot-spinner__dot"></div>
                <div className="dot-spinner__dot"></div>
                <div className="dot-spinner__dot"></div>
              </div>
            </div>
          </div>
        </div>
      ) : data ? (
        <div className="modal-overlay">
          <div className="modal-container">
            <button
              className="newnetwork-back-button-select-network"
              onClick={() => {
                setData(null);
                setTransactionDetails(null);
                onClose();
              }}
            >
              &#8592;
            </button>
            <h1>Transaction History</h1>
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >                       
              </div>
              <div style={{ 
  background: "#f9f9f9", 
  padding: "15px", 
  borderRadius: "10px", 
  boxShadow: "0px 4px 10px rgba(0,0,0,0.1)", 
  marginTop: "20px" 
}}>
<div style={{ fontFamily: "Arial, sans-serif", maxWidth: "400px", margin: "auto", padding: "20px", borderRadius: "10px", background: "#fff", boxShadow: "0px 4px 10px rgba(0,0,0,0.1)" }}>
  <h3 style={{ textAlign: "center", color: "#333", marginBottom: "15px" }}>
    {(() => {
      if ((selectedNetwork.chainId === 103 || selectedNetwork.chainId === 101) && transactionDetails?.type === "native") {
        return "Sent SOL";
      } else if ((selectedNetwork.chainId === 103 || selectedNetwork.chainId === 101) && transactionDetails?.type === "token") {
        return "Sent SPL";
      } else if (transactionDetails?.type === "token" && (selectedNetwork.chainId === 1 || selectedNetwork.chainId === 11155111)) {
        return "Sent ERC20";
      } else if (transactionDetails?.type === "native" && (selectedNetwork.chainId === 1 || selectedNetwork.chainId === 11155111)) {
        return "Sent ETH";
      } else if (transactionDetails?.type === "token" && (selectedNetwork.chainId === 137 || selectedNetwork.chainId === 80002)) {
        return "Sent ERC20";
      } else if (transactionDetails?.type === "native" && (selectedNetwork.chainId === 137 || selectedNetwork.chainId=== 80002)) {
        return "Sent MATIC";
      } else if (transactionDetails?.type === "token" && (selectedNetwork.chainId === 56 || selectedNetwork.chainId === 97)) {
        return "Sent ERC20";
      } else if (transactionDetails?.type === "native" && (selectedNetwork.chainId === 56 || selectedNetwork.chainId === 97)) {
        return "Sent BNB";
      } else if (transactionDetails?.type === "token" && (selectedNetwork.chainId === 43114 || selectedNetwork.chainId === 43113)) {
        return "Sent ERC20";
      } else if (transactionDetails?.type === "native" && (selectedNetwork.chainId === 43114 || selectedNetwork.chainId === 43113)) {
        return "Sent AVAX";
      }
      return "Transaction Details";
    })()}
  </h3>
      <div style={{ 
  marginTop: "10px", 
  paddingTop: "10px", 
  display: "flex", 
  justifyContent: "space-between",
  alignItems: "center"
}}>
  <p style={{ fontSize: "12px", color: "#777", marginBottom: "5px" }}>To:</p>
  <p style={{ fontSize: "10.5px", color: "#222",fontWeight: "bold", marginBottom: "5px" }}>{transactionDetails?.to}</p>
</div>
<div style={{ 
  marginTop: "10px", 
  paddingTop: "10px", 
  display: "flex", 
  justifyContent: "space-between",
  alignItems: "center"
}}>
  <p style={{ fontSize: "12px", color: "#777", marginBottom: "5px", fontWeight: "bold" }}>From:</p>
  <p style={{ fontSize: "10.5px", color: "#222", marginBottom: "5px",fontWeight: "bold"  }}>{transactionDetails?.from}</p>
</div>
      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "5px" }}>
  <p style={{ fontSize: "14px", color: "#555" }}>Network:</p>
  <p style={{ fontSize: "14px", fontWeight: "bold", color: "#222" }}>
    {(() => {
    if (selectedNetwork.chainId === 103) {
      return "solana DevNet";
    } else if (selectedNetwork.chainId === 101) {
      return "solana Main Net";
    } else if (selectedNetwork.chainId === 43113) {
      return "Avalanche C-Chain Fuji";
    } else if (selectedNetwork.chainId === 43114) {
      return "Avalanche C-Chain Mainnet";
    } else if (selectedNetwork.chainId === 97) {
      return "BSC testnet";
    } else if (selectedNetwork.chainId === 56) {
      return "BSC";
    } else if (selectedNetwork.chainId === 80002) {
      return "Polygon Amoy";
    } else if (selectedNetwork.chainId === 137) {
      return "Polygon";
    } else if (selectedNetwork.chainId === 11155111) {
      return "Sepolia testnet";
    } else if (selectedNetwork.chainId === 1) {
      return "Ethereum Mainnet";
    }
    return "Not Provided";    
    })()}
  </p>
</div>
 <div style={{ display: "flex", justifyContent: "space-between", marginTop: "5px" }}>
      <p style={{ fontSize: "14px", color: "#555" }}>Value:</p>
      <div style={{ display: "flex", alignItems: "center" }}>
        <p style={{ fontSize: "14px", fontWeight: "bold", color: "#222" }}>
        {(data?.amount || data?.value) 
  ? ((data.amount || data.value).length > 26 
      ? `${(data.amount || data.value).slice(0, 22)}...` 
      : (data.amount || data.value)) 
  : "N/A"}
        </p>
        </div>      </div>
      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "5px" }}>
      <p style={{ fontSize: "14px", color: "#555" }}>Transaction Hash:</p>

      <div style={{ display: "flex", alignItems: "center" }}>
        <p style={{ fontSize: "14px", fontWeight: "bold", color: "#222" }}>
        {data?.hash?.length > 26 ? `${data.hash.slice(0, 22)}...` : data?.hash}
        </p>
        </div>      </div>
        <button
                  onClick={handleCopy} 
                  style={{
                    width: "100%",
                    marginTop: "15px",
                    padding: "10px",
                    borderRadius: "8px",
                    backgroundColor: "#ddd",
                    color: "#666",
                    border: "none",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
     Copy hash to clipboard
      </button>
      <button
  onClick={() => window.open(data?.link, "_blank")} // Opens the link in a new tab
  style={{
    width: "100%",
    marginTop: "15px",
    padding: "10px",
    borderRadius: "8px",
    backgroundColor: "#ddd",
    color: "#666",
    border: "none",
    fontWeight: "bold",
    cursor: "pointer",
  }}>
  Inspect Transaction
</button>
    </div>
</div>
            </div>
          </div>
        </div>
      ) : (
        <div className="modal-overlay">
          <div className="modal-container">
            <button className="newnetwork-back-button-select-network" onClick={onClose}>
              &#8592;
            </button>
             <h1 className="modal-title">Send</h1>
            <form className="modal-form" onSubmit={handleSend}>
           
    <div>
      <h3>Select Network</h3>
      <select
  className="network-selection"
  onChange={handleSelectChange}
  value={selectedNetwork?.chainId || ""}
  autoFocus
>
  <option value="">Select a Network</option>
  {availableNetworks.map((network) => (
    <option key={network.chainId} value={network.chainId}>
      {network.name}
    </option>
  ))}
</select>

    </div>
  
    <div className="form-group">
                <label htmlFor="send-from">Send from</label>
                <select
                  id="send-from"
                  className="form-input"
                  value={sendFrom}
                >
                  <option>{sendFrom}</option>
                </select>
              </div>
    <div className="form-group">
                <label htmlFor="send-to">Send To</label>
                <input
                  id="send-to"
                  required
                  type="text"
                  value={sendTo}
                  onChange={(e) => setSendTo(e.target.value)}
                  className="form-input-input"
                  placeholder="Enter address"
                />
              </div>
  
<div className="form-group">
  <label htmlFor="asset">Asset</label>

  {loadingAssets ? (
    
    <div style={{ display: "flex", justifyContent: "center", margin: "10px 0" }}>
     <SyncLoader color="rgb(190, 107, 237)" size={9} />
      
    </div>
   
  ) : (
    <select
      id="asset"
      required
      className="form-input"
      value={asset}
      onChange={(e) => {
        const selectedAddress = e.target.value;
        const selectedIdx = e.target.selectedIndex - 1;

        const selected = assets.find((a) => a.address === selectedAddress);

        if ( selectedIdx === 0 || selected?.address === "Native" || selected?.symbol === "SOL" ) {
          setAsset("Native");
        } else {
          setAsset(selectedAddress);
        }

        setSelectedAsset(selected);
        setSelectedAssetBalance(selected?.balance ?? null);
        setSelectedAssetIndex(selectedIdx);
      }}
    >
      <option value="" disabled>
        Select Asset
      </option>

      {assets.map((res, index) => (
        <option
          key={index}
          value={res.address}
          style={{
            fontWeight: index === 0 ? "bold" : "normal",
            color: index === 0 ? "goldenrod" : "inherit",
          }}
        >
          {res.symbol?.slice(0, 6) }
        </option>
      ))}
    </select>
  )}
</div>

{selectedAssetBalance !== null && (
  <div style={{ marginTop: "10px", fontWeight: "bold", fontSize: "14px", color: "#4caf50" }}>
    Balance: {selectedAssetBalance}
  </div>
)}
<div className="form-group">
  <label htmlFor="amount">Amount</label>
  <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
    <input
      id="amount"
      type="number"
      step="any"
      value={amount}
      onChange={(e) => setAmount(e.target.value)}
      className="form-input-input"
      placeholder="0.00"
      pattern="[0-9]*[.]?[0-9]*"
      required
    />
   {selectedAssetBalance !== null && (
  <button
    type="button"
    onClick={() => {
      let actualAmount = parseFloat(selectedAssetBalance);
      let isNative = asset === "Native";

      if (isNative) {
        const fee = actualAmount * 0.30; // 3% fee
        actualAmount = (actualAmount - fee); // Optional: round off
        setFeeMessage("30% fee deducted for transfer");
      } else {
        setFeeMessage(""); // No message for non-native
      }
      setAmount(actualAmount);
    }}
    style={{
      padding: "5px 10px",
      backgroundColor: "#4caf50",
      color: "white",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer"
    }}
  >
    Max
  </button>
)}
  </div>
</div>
{feeMessage && (
  <div style={{ marginTop: "5px", color: "orangered", fontSize: "13px" }}>
    {feeMessage}
  </div> )}
              <div className="modal-actions">
                <button type="button" className="cancel-button" onClick={onClose}>
                  Cancel
                </button>
                <button type="submit" className="send-button">
                  Send
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};
export default SendModal;